module.exports = __webpack_public_path__ + "static/img/login-bg1.ceb5709.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-bg1.jpg
// module id = HqcA
// module chunks = 128